export const dndData = {
  elements: {},
  columns: {
    'column-1': {
      columnId: 'column-1',
      title: '',
      elementsIds: [],
    },
  },
  columnOrder: ['column-1'],
};
